module.exports = __webpack_public_path__ + "static/media/edit.fda31c5a.svg";